<script lang="ts">
	export let justifyBetween = false;
	export let wrapperClass = '';
	export let containerClass = '';
</script>

<div class="wrapper-scroll {wrapperClass}">
	<div class="container {containerClass}" class:justify-between-md={justifyBetween}>
		<slot />
	</div>
</div>

<style>
	.wrapper-scroll {
		width: 105%;
		overflow-x: auto;
}
	@media (min-width: 768px) {
		.wrapper-scroll {
				width: 100%;
		}
}
	.wrapper-scroll {
		margin-top: 1rem;
		margin-bottom: 1rem;
		scrollbar-width: none;
		-ms-overflow-style: none;
}

	.wrapper-scroll::-webkit-scrollbar {
		display: none;
	}

	.container {
		display: flex;
		width: -moz-fit-content;
		width: fit-content;
		gap: 1rem;
}

	@media (min-width: 768px) {
		.container {
				width: 100%;
		}
		.justify-between-md {
				justify-content: space-between;
		}
}
</style>
